import { defineEntityContract, type EntityByIdRequests, type EntityStateEvents, type QueuedChangeFailureEvents } from 'shared/channels/entity';
import type {
  CreateContractRequest,
  EditContractRequest,
} from 'shared/domain/messages/contract/eventMessages';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type { ContractModel } from './types/model';

/**
 * Contract events. A create answers with the saved model; the other outcome
 * payloads stay `unknown`: the HTTP queue sends the server's DTO after an
 * edit and `{ error, messageId }` with a failure.
 */
export type ContractEvents = EntityStateEvents & QueuedChangeFailureEvents & {
  [DomainMessagesTypes.allContracts]: { hasAll?: boolean; items: ContractModel[] };
  [DomainMessagesTypes.createdEntity]: ContractModel;
  // A restore (queued as GET) answers `true`.
  [DomainMessagesTypes.uploadedEntity]: unknown;
  [DomainMessagesTypes.updatedEntity]: unknown;
  [DomainMessagesTypes.deletedEntity]: unknown;
};

/**
 * One contract for its details view, and the contract changes: each change resolves
 * once queued, its outcome follows as an event with its `uniqueId`.
 */
export type ContractRequests = EntityByIdRequests<ContractModel> & {
  create: { request: CreateContractRequest; response: void };
  edit: { request: EditContractRequest; response: void };
};

export const contractChannelContract = defineEntityContract<ContractModel, ContractEvents, ContractRequests>(
  'contractChannel',
  { collectionEvent: DomainMessagesTypes.allContracts }
);
